import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useSelector } from "react-redux";
import { updateConfig } from "../../../store/slices/ActivityLog/activitylogSlice";
import { debounce } from "lodash";
import { subDays } from "date-fns";
import {
  useGetActivityLogDataQuery,
  useUpdateActivityLogTableHeadDataMutation,
} from "../../../store/queries/ActivityLog";
import { useFormik } from "formik";
import {
  useGetDepartmentListDataQuery,
  useGetDepartmentActivityLogDataQuery,
} from "../../../store/queries/Master";
import { deleteActivityLog, downloadActivityLog } from "./api";
import moment from "moment";
import { toast } from "react-toastify";

const useActivityLog = () => {
  const [loading, setLoading] = useState();
  const globalState = useSelector((state) => state.global);

  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const activitylogState = useSelector((state) => state.activitylog);
  // eslint-disable-next-line no-unused-vars
  const [date, setDate] = useState({
    startDate: subDays(new Date(), 30),
    endDate: new Date(),
    key: "selection",
  });
  // const startDate = new Date(date.startDate).toISOString().split("T")[0];
  // const endDate = new Date(date.endDate).toISOString().split("T")[0];
  // const initialFormattedDate = [startDate, endDate];
  // const [formattedDate, setFormattedDate] = useState(initialFormattedDate);
  const dispatch = useDispatch();
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const formik = useFormik({
    initialValues: {
      department: "",
      activitytype: "",
      branch_id: "",
    },
  });
  const { data: departmentData = {} } = useGetDepartmentListDataQuery({});
  const { data: activitylogData = {} } = useGetDepartmentActivityLogDataQuery(
    {},
  );
  const {
    data: activitylogList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetActivityLogDataQuery({
    page_size: activitylogState?.currentPageSize,
    page: activitylogState?.currentPage,
    search: activitylogState?.search,
    date: activitylogState?.date,
    department_id: formik?.values?.department?._id,
    activity_type: formik?.values?.activitytype?.value,
    branch_id: formik?.values?.brach_id?._id,
  });

  const [updateEstimateFields] = useUpdateActivityLogTableHeadDataMutation();

  useEffect(() => {
    dispatch(
      globalUpdateConfig((state) => {
        state.tableFields = activitylogList?.data?.fields;
      }),
    );
    // eslint-disable-next-line
  }, [activitylogList]);

  const getRow = (feild, data) => {
    const rows = {
      common: (feild, data) => <p className="pro-mb-0">{data[feild]}</p>,
      service: (feild, data) => (
        <ul>
          {data[feild]?.map(({ name }, index) => (
            <li key={index}>{name}</li>
          ))}
        </ul>
      ),
    };
    return rows?.[feild]?.(feild, data) ?? rows["common"](feild, data);
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      }),
    );
  };
  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      }),
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      }),
    );
  };

  const handleSort = (label) => {
    if (activitylogState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            activitylogState.sortOrder === "asc" ? "desc" : "asc";
        }),
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        }),
      );
    }
  };

  const handleSearchDebounced = debounce((value, dispatch) => {
    dispatch(
      updateConfig((state) => {
        state.search = value;
        state.currentPage = 1;
      }),
    );
  }, 1000);

  const handleSearch = (e) => {
    handleSearchDebounced(e.target.value, dispatch);
  };

  const handleDateChange = (date) => {
    const startDateUTC = new Date(date.startDate);
    const endDateUTC = new Date(date.endDate);
    const timeZoneOffset = 5.5 * 60 * 60 * 1000;
    const startDateIST = new Date(startDateUTC.getTime() + timeZoneOffset);
    const endDateIST = new Date(endDateUTC.getTime() + timeZoneOffset);

    const formatDate = (date) => {
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const startDateFormatted = formatDate(startDateIST);
    const endDateFormatted = formatDate(endDateIST);
    const dateArray = [startDateFormatted, endDateFormatted];
    dispatch(updateConfig((state) => (state.date = dateArray)));
  };
  const handleClick = () => {
    setLoading(true);
    let data = {
      page_size: activitylogState?.currentPageSize,
      page: activitylogState?.currentPage,
      search: activitylogState?.search,
      date: activitylogState?.date,
      department_id: formik?.values?.department?._id,
      activity_type: formik?.values?.activitytype?.value,
    };

    downloadActivityLog(data).then((response) => {
      setLoading(false);

      if (response?.status === 200 && response?.data?.data?.original) {
        const csvString = response.data.data.original;

        // Convert CSV string → Blob
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);

        // Create download link
        const downloadLink = document.createElement("a");
        downloadLink.href = url;
        downloadLink.setAttribute(
          "download",
          `Activity log_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.csv`,
        );

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const handleDeleteModal = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showDeleteModal = !state.showDeleteModal;
        state.selectedItem = e?.[0];
      }),
    );
  };

  const handleDelete = () => {
    deleteActivityLog().then((response) => {
      if (response?.data?.status_code === 200) {
        toast.success("Item deleted successfully");
        handleDeleteModal();
        refetch();
      } else {
        toast.error("Something went wrong");
        handleDeleteModal();
      }
    });
  };

  return {
    paginationOptions,
    activitylogList,
    isLoading,
    isFetching,
    tableFields,
    showEditModal,
    activitylogState,
    globalState,
    date,
    handleClick,
    handleDateChange,
    handleSearch,
    handleSort,
    handlePageSize,
    handlePagination,
    updateEstimateFields,
    handleEditColumnsClick,
    handleDeleteModal,
    handleDelete,
    refetch,
    getRow,
    formik,
    departmentData,
    activitylogData,
  };
};

export default useActivityLog;
